var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    ("" + _vm.classPrefix),
    _vm.dot && (_vm.classPrefix + "--dot"),
    _vm.status && (_vm.classPrefix + "--status " + _vm.classPrefix + "--status-" + _vm.status),
    _vm.alone && (_vm.classPrefix + "--alone"),
    _vm.isColor && (_vm.classPrefix + "--" + _vm.color)
]},[(!_vm.status)?_vm._t("default"):_vm._e(),(_vm.supShow)?_c('sup',{class:[(_vm.classPrefix + "__sup")],style:(_vm.supStyle),attrs:{"title":_vm.supTitle}},[_vm._v(_vm._s(_vm.supText))]):_vm._e(),(_vm.status)?_c('span',{class:[(_vm.classPrefix + "__status-text")]},[_vm._v(_vm._s(_vm.text))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }